import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    featured: 'fw-bold'
  }
} satisfies CMSConfig['megaMenuL3Desktop']
